import React from 'react';
import clsx from 'clsx';

interface InfoBoxProps {
    icon: string;
    content: string;
    hasMargin?: boolean;
}

export default function InfoBox({ icon, content, hasMargin = false }: InfoBoxProps) {

     // add class  has-margin if hasMargin prop is true
     const hasMarginClass = clsx({ 'info-box--has-margin': hasMargin });

    return (
        <div className={ clsx(hasMarginClass ,'info-box')}>

            <div
                className={clsx('info-box__icon')}
                dangerouslySetInnerHTML={{ __html: icon }}
                suppressHydrationWarning
            />

            <div
                className={clsx('info-box__content rich-text')}
                dangerouslySetInnerHTML={{ __html: content }}
                suppressHydrationWarning
            />
        </div>
    );
}
